import { jsx as _jsx } from "react/jsx-runtime";
import { Renderer_SearchResult } from '@app/styles';
import { EditableDBItemV3 } from '@nu-art/thunderstorm-frontend/index';
import { MUSTNeverHappenException } from '@nu-art/ts-common';
import { DBDef_FAQ, DBDef_FindingView } from '@app/advisor-ui-shared';
import { Editor_FindingView } from '../Editor_FindingView/Editor_FindingView.js';
import { Editor_FAQ } from '../Editor_FAQ/Editor_FAQ.js';
import { ModuleFE_FindingView } from '../../_entity/finding-view/ModuleFE_FindingView.js';
import { ModuleFE_FAQ } from '../../_entity/frequently-asked-question/ModuleFE_FAQ.js';
export const SearchableItem_FindingView = {
    type: DBDef_FindingView.dbKey,
    entityName: DBDef_FindingView.entityName,
    module: ModuleFE_FindingView,
    route: { key: 'advisor-ui' },
    groupId: ['Advisor-UI'],
    entityLabel: 'Finding View',
    tags: [],
    mapper: (item) => [item.label],
    renderer: (item, selected, onClickCallback) => {
        return _jsx(Renderer_SearchResult, { itemId: item._id, itemKey: DBDef_FindingView.dbKey, itemLabel: item.label, entityLabel: 'Finding View', hierarchy: 'Advisor UI', selected: selected, onClickCallback: onClickCallback });
    },
    resultRenderer: (id) => {
        const findingView = ModuleFE_FindingView.cache.unique(id);
        if (!findingView)
            throw new MUSTNeverHappenException(`Could not find a finding view for the given id ${id}`);
        const editable = new EditableDBItemV3(findingView, ModuleFE_FindingView);
        return _jsx(Editor_FindingView, { editable: editable });
    }
};
export const SearchableItem_FAQ = {
    type: DBDef_FAQ.dbKey,
    entityName: DBDef_FAQ.entityName,
    module: ModuleFE_FAQ,
    route: { key: 'advisor-ui' },
    groupId: ['Advisor-UI'],
    entityLabel: DBDef_FAQ.entityName,
    tags: [],
    mapper: item => [item.label],
    renderer: (item, selected, onClickCallback) => {
        return _jsx(Renderer_SearchResult, { itemId: item._id, itemKey: DBDef_FAQ.dbKey, itemLabel: item.label, entityLabel: DBDef_FindingView.entityName, hierarchy: 'Advisor UI', selected: selected, onClickCallback: onClickCallback });
    },
    resultRenderer: (id) => {
        const faq = ModuleFE_FAQ.cache.unique(id);
        if (!faq)
            throw new MUSTNeverHappenException(`Could not find an FAQ for the given id ${id}`);
        const editable = new EditableDBItemV3(faq, ModuleFE_FAQ);
        return _jsx(Editor_FAQ, { editable: editable });
    }
};
export const getAdvisorUIManagerSearchItems = () => [SearchableItem_FindingView, SearchableItem_FAQ];
export const workspaceKey_Page_AdvisorUI = 'workspace__page__advisor-ui';
export const WorkspaceConfig_Page_AdvisorUI = {
    name: workspaceKey_Page_AdvisorUI,
    key: 'horizontalSpace',
    visible: true,
    factor: 1,
    min: -1,
    data: {
        panels: [
            { name: 'LeftPanel', key: 'list', visible: true, factor: 1.5 / 5, min: 450, data: {} },
            { name: 'RightPanel', key: 'editor', visible: true, factor: 3.5 / 5, min: 1100, data: {} },
        ]
    }
};
//# sourceMappingURL=consts.js.map